// client/src/coms/voip/voiceMasterVolume.js
// One volume for everyone's voices (on top of per-person volumes), kept separate from the soundboard's
// own volume so neither has to be turned down to balance the other.
const KEY = 'vox:voiceMasterVolume';

export function getVoiceMasterVolume() {
  try {
    const n = Number(localStorage.getItem(KEY));
    return localStorage.getItem(KEY) == null || !Number.isFinite(n) ? 1 : Math.max(0, Math.min(1, n));
  } catch {
    return 1;
  }
}

export function setVoiceMasterVolume(v) {
  const n = Math.max(0, Math.min(1, Number(v) || 0));
  try {
    localStorage.setItem(KEY, String(n));
  } catch {}
  try {
    // Re-applies volumes to every remote voice element (see proximity.js bindParticipantPrefsOnce).
    window.dispatchEvent(new CustomEvent('pa-coms-voice-participant-prefs-changed', { detail: {} }));
  } catch {}
  return n;
}
